import React from 'react';
import RadialBarChart from 'react-apexcharts';

const RadialChart = props => {
  const { value, color, textColor } = props;
  const chartData = {
    fill: {
      colors: color,
    },
    chart: {
      type: 'radialBar',
      offsetY: 5,
    },
    series: [value],
    plotOptions: {
      radialBar: {
        track: {
          background: '#FFF',
        },
        hollow: {
          margin: 10,
          size: '30%',
        },
        dataLabels: {
          showOn: 'always',
          name: {
            show: false,
          },
          value: {
            offsetY: 5,
            color: textColor,
            fontSize: '0.8rem',
            fontFamily: 'Open Sans, sans-serif',
            show: true,
          },
        },
      },
    },
    stroke: {
      lineCap: 'round',
    },
    responsive: [
      {
        breakpoint: 1460,
        options: {
          chart: {
            height: 130,
            width: 80,
          },
        },
      },
      {
        breakpoint: 1860,
        options: {
          chart: {
            height: 160,
            width: 100,
          },
        },
      },
    ],
  };

  return (
    <RadialBarChart
      options={chartData}
      series={chartData.series}
      type="radialBar"
      height={180}
      width={120}
    />
  );
};

export default RadialChart;
